export function Container({ children }: { children: React.ReactNode }) {
  return (
    <div className="container mx-auto px-3 min-[375px]:px-4 sm:px-5 md:px-6 lg:px-8 xl:px-10 2xl:px-12">
      {children}
    </div>
  );
}

